<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" custom-class="edit-goods-dialog" top="5vh" width="1200px" :fullscreen="isExpand" :show-close="false" :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false">
      <template slot="title">
        <div class="default-dialog-title-box">
          <div>
            {{ form.id && !chooseGoods && ctrlType !== 'publish' ? '编辑商品' : '发布商品' }}
            <span v-if="from === 'subscribe' && form.id && !chooseGoods && ctrlType !== 'publish'" class="title-bar">
              如需修改商品档案基础信息，请点击此处
              <b @click="handleModifyGoods" class="btn">修改商品档案</b> 。修改完成后档案信息会自动同步至商品发布信息
            </span>
            <span v-else-if="from === 'subscribe' && ctrlType !== 'publish'" class="title-bar">
              如需对未发布的商品进行发布，请点击此处
              <b @click="handleSelectGoods" class="btn">选择商品</b>
            </span>
          </div>
          <span class="icon-box">
            <img :src="!isExpand ? expandSvg : collapseSvg" @click="isExpand = !isExpand">
            <i class="el-icon-close" @click="handleClose"></i>
          </span>
        </div>
      </template>
      <el-form :model="form" ref="JZForm" :rules="rules" label-position="right" label-width="110px" size="mini">
        <el-row>
          <el-col :span="8">
            <el-form-item label="商品编码(sku)" prop="sn">
              <el-input v-model.trim="form.sn" disabled placeholder="sku码自动生成"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="商品名称" prop="goodsName">
              <el-input v-model.trim="form.goodsName" :disabled="from === 'subscribe' && disabled" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="商品别名" prop="anotherName">
              <el-input v-model.trim="form.anotherName" clearable placeholder="如输入多个，请用“，”隔开"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="型号" prop="model">
              <el-input v-model.trim="form.model" :disabled="from === 'subscribe' && disabled" clearable placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="规格">
              <el-input v-model.trim="simpleSpecs" :disabled="from === 'subscribe' && disabled" clearable placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="计量单位" prop="goodsUnit">
              <el-select v-model="form.goodsUnit" :disabled="from === 'subscribe' && disabled" filterable placeholder="请选择">
                <el-option v-for="(unit, index) in goodsUnitList" :key="'unit-'+index" :label="unit.optionValue" :value="unit.optionValue"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <template v-if="from !== 'subscribe'">
              <el-form-item label="平台商品分类" prop="categoryId">
                <ChooseGoodsPlatFormCategory ref="chooseGoodsPlatFormCategoryRef" :useXieApi="from !== 'subscribe'" type="MEDICAL" checkStrictly @handleValidate="handleValidate" @handleSelect="handleSelectPlatFormCategory" />
              </el-form-item>
            </template>
            <template v-if="from === 'subscribe'">
              <el-form-item label="商品分类" prop="merchantGoodsCategoryId">
                <ChooseGoodsCategory ref="chooseGoodsCategoryRef" checkStrictly @handleValidate="handleValidate" @handleSelect="handleSelectCategory" />
              </el-form-item>
            </template>
          </el-col>
          <el-col :span="8">
            <el-form-item label="商品品牌" prop="brandName">
              <el-select v-model="form.brandName" @change="handleChangeBrand" @clear="handleClearBrand" :disabled="from === 'subscribe' && disabled" filterable remote :remote-method="remoteQueryBrand" value-key="id" placeholder="请选择" clearable>
                <el-option v-for="(brand, index) in brandList" :key="'brand-'+index" :label="brand.name" :value="brand"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="原厂备件号" prop="storeSn">
              <el-input v-model.trim="form.storeSn" clearable placeholder="请输入，可输入备件码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <template v-if="from === 'subscribe'">
              <el-form-item label="商品类型" prop="rootCategoryCode">
                <el-radio-group v-model="form.rootCategoryCode" @change="handleChangeRootCategory">
                  <el-radio label="PART">零配件</el-radio>
                  <el-radio label="DEVICE">设备</el-radio>
                </el-radio-group>
              </el-form-item>
            </template>
          </el-col>
          <el-col :span="8">
            <el-form-item label="医疗件属性" prop="medicalFlag">
              <el-radio-group v-model="form.medicalFlag" :disabled="from === 'subscribe' && disabled" @change="handleChangeMedical">
                <el-radio :label="1">医疗</el-radio>
                <el-radio :label="0">非医疗</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col v-if="form.medicalFlag === 1" :span="8">
            <el-form-item label="注册证/备案凭证号" prop="registerCode" label-width="140px">
              <template v-if="!(from === 'subscribe' && disabled)">
                <template v-if="form.registerCode">
                  <el-input v-model.trim="form.registerCode" readonly>
                    <el-button @click="() => form.registerCode = null" slot="append" icon="el-icon-delete"></el-button>
                  </el-input>
                </template>
                <template v-else>
                  <span @click="handleChooseRegisterNo" class="button" style="padding-left: 0;">选择注册证</span>
                  <span>未找到?</span>
                  <span @click="handleAddRegisterNo" class="button">手动新增</span>
                </template>
              </template>
              <span v-else style="color: #559fff">{{ form.registerCode || '--' }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="质保期/保修期" prop="qualityAssPeriod"
              :rules="[{
                required: this.form.medicalFlag === 1 || false,
                message: '请选择质保期/保修期',
                trigger: ['blur', 'change']
              }]">
              <el-input v-model.trim="form.qualityAssPeriod" type="number" :min="0" clearable placeholder="请输入" style="width: 60%;" />
              <el-select v-model="form.qualityAssPeriodUnitName" clearable placeholder="请选择" style="width: 40%;" >
                <el-option v-for="(unit,index) in qualityAssPeriodUnitEnums" :label="unit.label" :value="unit.value" :key="'unit-'+index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.rootCategoryCode === 'PART'">
          <el-col :span="8">
            <el-form-item label="适配设备" prop="deviceType">
              <div class="device-box">
                <div class="device-ctrl">
                  <el-tooltip class="item" effect="dark" content="如选择商品分类为零配件，请填写适配设备类型信息" placement="top">
                    <i class="el-icon-warning-outline" style="margin: 0 5px;"></i>
                  </el-tooltip>
                  <div @click="handleSelectDevice" class="button" :style="{'color': from === 'subscribe' && disabled ? '#559fff' : '', 'padding': '5px 0'}">
                    <el-tooltip
                      v-if="form.deviceType === '1'"
                      :content="deviceList.length ? deviceList.map(item => `${item.deviceName} ${item.deviceBrandName} ${item.deviceModel}`).join('；') : '--'"
                      placement="bottom" class="item" effect="dark">
                      <span>固定设备</span>
                    </el-tooltip>
                    <span v-else>{{ form.deviceType === '2' ? '通用' : !(from === 'subscribe' && disabled) ? '选择设备' : '未选择设备' }}</span>
                  </div>
                  <i v-if="form.deviceType && !(from === 'subscribe' && disabled)" @click="handleClearDevice" class="el-icon-circle-close" style="padding-left: 5px;"></i>
                </div>
                <!-- <div class="device-list">
                  <div v-for="(device, index) in deviceList" :key="'device'+index" class="device">
                    <span :style="{'color': disabled ? '#559fff' : ''}">{{ `${device.deviceName} ${device.deviceBrandName} ${device.deviceModel}` }}</span>
                    <i v-if="!disabled" @click="handleDeleteDevice(index)" class="el-icon-circle-close" style="padding-left: 15px;"></i>
                  </div>
                </div> -->
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <div class="brand-category-box">
              <div class="device-ctrl">
                <span class="label">适配品牌</span>
                <div @click="handleSelectDeviceBrand" class="button">
                  <span v-if="form.adaptedBrandType === 2">通用</span>
                  <el-tooltip
                    v-else-if="adaptedBrandList.length"
                    :content="adaptedBrandList.map(item => item.brandName).join('；')"
                    placement="bottom" class="item" effect="dark">
                    <span>{{ `${adaptedBrandList[0].brandName} ${adaptedBrandList.length > 1 ? '、+'+(adaptedBrandList.length - 1) : ''}` }}</span>
                  </el-tooltip>
                  <span v-else>选择</span>
                </div>
                <i v-if="form.adaptedBrandType || adaptedBrandList.length" @click="handleClearDeviceBrand" class="el-icon-circle-close" style="padding-left: 5px;"></i>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="brand-category-box">
              <div class="device-ctrl">
                <span class="label">适配设备分类</span>
                <div @click="handleSelectDeviceCategory" class="button">
                  <span v-if="form.adaptedCategoryType === 2">通用</span>
                  <el-tooltip
                    v-else-if="adaptedCategoryList.length"
                    :content="adaptedCategoryList.map(item => item.categoryName).join('；')"
                    placement="bottom" class="item" effect="dark">
                    <span>{{ `${adaptedCategoryList[0].categoryName} ${adaptedCategoryList.length > 1 ? '、+'+(adaptedCategoryList.length - 1) : ''}` }}</span>
                  </el-tooltip>
                  <span v-else>选择</span>
                </div>
                <i v-if="form.adaptedCategoryType || adaptedCategoryList.length" @click="handleClearDeviceCategory" class="el-icon-circle-close" style="padding-left: 5px;"></i>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="商品图片" prop="imageList">
              <Upload
                v-model.trim="imagesList"
                @success="handleFileLists"
                @remove="handleRemove"
                accept="image/png,image/jpeg,image/jpg"
                :maxSize="10"
                size="small"
                :tip="false"
                :limit="10"
              >
              </Upload>
              <div class="tip-upload">支持上传jpg、jpeg、png格式的文件，文件大小不得超过10M，最多上传 10 张</div>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="line" style="margin-top: 0;"></div>
        <el-row>
          <el-col :span="8">
            <el-form-item label="商品数量" prop="quantity">
              <el-input v-model.trim="form.quantity" type="number" :min="0" clearable placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="销售单价" prop="price">
              <el-input v-model.trim="form.price" type="number" :min="0" clearable placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="上下架状态" prop="marketEnable">
              <el-select v-model="form.marketEnable" placeholder="请选择" clearable filterable>
                <el-option label="上架" value="UPPER"></el-option>
                <el-option label="下架" value="DOWN"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form :model="form" ref="serialListRef" :rules="rules">
              <el-form-item label="" label-width="110px" prop="serialList">
                <xz-table
                  :bordered="true"
                  :columns="columns"
                  :data="form.serialList"
                  :scroll="{ x: 0, y: 'auto' }"
                  :editable="true"
                  rowKey="index">
                  <span slot="warehouseName" slot-scope="text, record">
                    <el-input
                      v-model.trim="record.warehouseName"
                      placeholder="请输入"
                      style="width: 100%"
                    />
                  </span>
                  <span slot="serialNo" slot-scope="text, record">
                    <el-input
                      v-model.trim="record.serialNo"
                      placeholder="请输入"
                      style="width: 100%"
                    />
                  </span>
                  <span slot="storageLocation" slot-scope="text, record">
                    <el-input
                      v-model.trim="record.storageLocation"
                      placeholder="请输入"
                      style="width: 100%"
                    />
                  </span>
                  <span slot="batchNo" slot-scope="text, record">
                    <el-input
                      v-model.trim="record.batchNo"
                      placeholder="请输入"
                      style="width: 100%"
                    />
                  </span>
                  <template slot="quantityTitle">
                    <span style="color: #F56C6C;">*</span>
                    数量
                  </template>
                  <span slot="quantity" slot-scope="text, record, index">
                    <el-form-item :prop="'serialList.' + index + '.quantity'" :rules="rules.quantity" style="margin-top: 15px;">
                      <el-input-number
                        v-model.trim="record.quantity"
                        placeholder="请输入"
                        :min="1"
                        :step="1"
                        style="width: 100%"
                        :precision="0"
                      />
                    </el-form-item>
                  </span>
                  <div slot="action" slot-scope="text, record, index">
                    <el-button v-if="index === 0" @click="handleAddRow" type="text" size="normal">新增行</el-button>
                    <el-button v-else @click="handleDeleteRow(index)" type="text" size="normal" style="color: #F56C6C;">删除行</el-button>
                  </div>
                </xz-table>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="商品描述" prop="sellingPoint">
              <el-input v-model.trim="form.sellingPoint" clearable placeholder="请输入" type="textarea" :rows="3"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span v-if="$withPermission('gongxutong:sale_goods:subscription:release')" slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button v-if="ctrlType !== 'publish'" type="primary" @click="handleSure('save')" plain>保存</el-button>
        <el-button type="primary" @click="handleSure('release')">发布</el-button>
      </span>
    </el-dialog>

    <SearchRegisterNoDialog ref="searchRegisterNoDialogRef" @select="handleSelectRegisterNo" />

    <CreateRegisterNoDialog ref="createRegisterNoDialogRef" @updateRegistration="getRegistration" />

    <ChooseDeviceDialog ref="chooseDeviceDialogRef" :useXieApi="from !== 'subscribe'" @saveDevice="handleSaveDevice" />

    <ChooseGoodsDialog ref="chooseGoodsDialogRef" :from="from" @handleSelect="handleChooseGoods" />

    <EditBaseDialog ref="editBaseDialogRef" from="shop" @refresh="handleBaseSku" />

    <ChooseDeviceBrandDialog ref="chooseDeviceBrandDialogRef" :useXieApi="from !== 'subscribe'" @saveDeviceBrand="handleSaveDeviceBrand" />

    <ChooseDeviceCategoryDialog ref="chooseDeviceCategoryDialogRef" :useXieApi="from !== 'subscribe'" @saveDeviceCategory="handleSaveDeviceCategory" />
  </div>
</template>
<script>
import _ from 'lodash';
import xzTable from '@/components/xiaozi-ui/xz-table/src/table.vue';
import { getOptionListMap } from '@/api/contract';
import { getBrandPageList, getBrandPageList1xie, skuDetail } from '@/api/goods';
import { goodsSkuAdd, goodsSkuUpdate, skuReleaseDetail, checkSkuChange } from '@/api/shop';
import { getAttributeDetail } from '@/api/attributeDict';
import SearchRegisterNoDialog from '@/views/Goods/components/searchRegisterNoDialog.vue';
import CreateRegisterNoDialog from '@/views/Goods/components/createRegisterNoDialog.vue';
import ChooseDeviceDialog from '@/views/Goods/components/chooseDeviceDialog.vue';
import ChooseDeviceBrandDialog from './chooseDeviceBrandDialog.vue';
import ChooseDeviceCategoryDialog from './chooseDeviceCategoryDialog.vue';
import ChooseGoodsCategory from '@/views/Goods/components/chooseGoodsCategory.vue';
import ChooseGoodsPlatFormCategory from '@/views/Goods/components/chooseGoodsPlatFormCategory.vue';
import ChooseGoodsDialog from './chooseGoodsDialog.vue';
import EditBaseDialog from '@/views/Goods/components/editDialog.vue';

const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};

const goodsRow = {
  warehouseName: '',
  serialNo: '',
  storageLocation: '',
  batchNo: '',
  quantity: 1,
};

export default {
  components: {
    Upload: () => import('@/components/common/upload'),
    xzTable,
    SearchRegisterNoDialog,
    CreateRegisterNoDialog,
    ChooseDeviceDialog,
    ChooseDeviceBrandDialog,
    ChooseDeviceCategoryDialog,
    ChooseGoodsCategory,
    ChooseGoodsPlatFormCategory,
    ChooseGoodsDialog,
    EditBaseDialog,
  },
  props: {
    from: {
      type: String,
      default: '',
    },
    storeId: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      ctrlType: null,
      isExpand: false,
      dialogVisible: false,
      expandSvg: require('@/assets/ic_expand.svg'),
      collapseSvg: require('@/assets/ic_collapse.svg'),
      simpleSpecs: '',
      disabled: false,
      chooseGoods: false,
      detail: {},
      form: {
        id: null,
        managerCategory: null,
        tenantId: userInfo?.tenantId,
        tenantName: userInfo?.tenantName,
        anotherName: null,
        brandId: null,
        brandName: null,
        deviceType: null,
        draftFlag: false,
        goodsName: null,
        goodsUnit: null,
        imageList: [],
        attributeMap: {},
        medicalFlag: 0,
        merchantGoodsCategoryId: null,
        merchantGoodsCategoryPath: null,
        categoryId: null,
        categoryPath: null,
        quantity: null,
        price: null,
        marketEnable: 'UPPER',
        saleTypes: ['PLATFORM_SALE'],
        model: null,
        qualityAssPeriod: null,
        qualityAssPeriodUnitName: '月',
        registerCode: null,
        storeSn: null,
        operatorId: userInfo?.id,
        operatorName: userInfo?.name,
        rootCategoryCode: null,
        sourceType: 'XIAOZI_PLATFORM',
        sellingPoint: '',
        serialList: [],
        adaptedBrandType: null,
        adaptedCategoryType: null,
      },
      imagesList: [],
      deviceList: [],
      adaptedBrandList: [],
      adaptedCategoryList: [],
      copyDeviceIncludesBrands: [],
      copyDeviceIncludesCategories: [],
      deviceIncludesBrands: [],
      deviceIncludesCategories: [],
      qualityAssPeriodUnitEnums: [],
      goodsUnitList: [],
      brandList: [],
      rules: {
        goodsName: [
          { required: true, message: '请输入商品名称', trigger: ['blur', 'change'] },
        ],
        model: [
          { required: true, message: '请输入商品型号', trigger: ['blur', 'change'] },
        ],
        categoryId: [
          { required: true, message: '请选择平台商品分类', trigger: ['blur', 'change'] },
        ],
        goodsUnit: [
          { required: true, message: '请选择计量单位', trigger: ['blur', 'change'] },
        ],
        quantity: [
          { required: true, message: '请输入商品数量', trigger: ['blur', 'change'] },
        ],
        price: [
          { required: true, message: '请输入销售单价', trigger: ['blur', 'change'] },
        ],
        marketEnable: [
          { required: true, message: '请选择上下架状态', trigger: ['blur', 'change'] },
        ],
        rootCategoryCode: [
          { required: true, message: '请选择商品类型', trigger: ['blur', 'change'] },
        ],
        merchantGoodsCategoryId: [
          { required: true, message: '请选择商品分类', trigger: ['blur', 'change'] },
        ],
        medicalFlag: [
          { required: true, message: '请选择医疗件属性', trigger: ['blur', 'change'] },
        ],
        registerCode: [
          { required: true, message: '请选择注册证/备案凭证', trigger: ['blur', 'change'] },
        ],
        deviceType: [
          { required: true, message: '请选择适配设备', trigger: ['blur', 'change'] },
        ],
        imageList: [
          { required: true, validator: this.validateImages, trigger: ['blur', 'change'] },
        ],
      },
      columns: [
        {
          title: '仓库名称',
          dataIndex: 'warehouseName',
          key: 'warehouseName',
          width: 120,
          scopedSlots: { customRender: 'warehouseName' },
        },
        {
          title: '序列号',
          dataIndex: 'serialNo',
          key: 'serialNo',
          width: 110,
          scopedSlots: { customRender: 'serialNo' },
        },
        {
          title: '货位号',
          dataIndex: 'storageLocation',
          key: 'storageLocation',
          width: 110,
          scopedSlots: { customRender: 'storageLocation' },
        },
        {
          title: '批次号',
          dataIndex: 'batchNo',
          key: 'batchNo',
          width: 110,
          scopedSlots: { customRender: 'batchNo' },
        },
        {
          originTitle: '数量',
          dataIndex: 'quantity',
          key: 'quantity',
          width: 100,
          scopedSlots: { title: 'quantityTitle', customRender: 'quantity' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          width: 60,
          scopedSlots: { customRender: 'action' },
        },
      ],
    };
  },
  watch: {
    dialogVisible (v) {
      if (!v) {
        this.init();
      } else {
        if (!this.qualityAssPeriodUnitEnums.length) {
          this.getUnitDictionaryData();
        }
        if (!this.goodsUnitList.length) {
          this.getGoodsUnitList();
        }
        this.getBrandList();
      }
    },
    'form.serialList': {
      handler () {
        this.handleQuantityChange();
      },
      deep: true,
      immediate: true,
    },
    deviceList: {
      handler (v) {
        setTimeout(() => {
          if (v?.length) {
            this.deviceIncludesBrands = v.map(item => item.deviceBrandId).filter(item => !!item);
            this.deviceIncludesCategories = v.map(item => item.deviceCategoryId).filter(item => !!item);
          } else {
            this.deviceIncludesBrands = [];
            this.deviceIncludesCategories = [];
          }

          if (!this.adaptedBrandList.length) {
            this.adaptedBrandList = (v || []).map(item => {
              if (item.deviceBrandId) {
                return {
                  brandId: item.deviceBrandId,
                  brandName: item.deviceBrandName,
                };
              }
            }).filter(item => !!item);
            this.copyDeviceIncludesBrands = _.cloneDeep(this.adaptedBrandList);
          }

          if (!this.adaptedCategoryList.length) {
            this.adaptedCategoryList = (v || []).map(item => {
              if (item.deviceCategoryId) {
                return {
                  categoryId: item.deviceCategoryId,
                  categoryName: item.deviceCategoryName,
                };
              }
            }).filter(item => !!item);
            this.copyDeviceIncludesCategories = _.cloneDeep(this.adaptedCategoryList);
          }
        }, 500);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    validateImages (rule, value, callback) {
      if (!value?.length) {
        callback(new Error('请上传商品图片'));
      } else {
        callback();
      }
    },
    handleAddRow () {
      this.form.serialList.push(_.cloneDeep(goodsRow));
    },
    handleDeleteRow (index) {
      this.form.serialList.splice(index, 1);
    },
    handleQuantityChange () {
      this.form.quantity = this.form.serialList.reduce((pre, cur) => pre + Number(cur.quantity), 0);
    },
    handleSelectGoods () {
      if (this.chooseGoods) {
        this.$confirm('选择商品会将当前选择的商品清空，确认去选择吗？', '选择商品', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(()=>{
          this.$refs.chooseGoodsDialogRef.saleType = 'SUBSCRIPTION_SALE';
          this.$refs.chooseGoodsDialogRef.dialogVisible = true;
        });
      } else {
        this.$refs.chooseGoodsDialogRef.saleType = 'SUBSCRIPTION_SALE';
        this.$refs.chooseGoodsDialogRef.dialogVisible = true;
      }
    },
    handleModifyGoods () {
      this.$refs.editBaseDialogRef.initForm(this.detail.baseSkuId);
      this.$refs.editBaseDialogRef.dialogVisible = true;
    },
    async handleChooseGoods (v) {
      this.chooseGoods = true;
      const { body } = await skuDetail({id: v.id, findDeviceFlag: true});
      this.handleBaseSku(body);
    },
    handleValidate () {
      this.$refs.JZForm.clearValidate('merchantGoodsCategoryId');
      this.$refs.JZForm.clearValidate('categoryId');
    },
    handleChangeRootCategory () {
    },
    handleClearDevice () {
      this.form.deviceType = null;
      this.deviceList = [];
      this.form.adaptedBrandType = null;
      this.form.adaptedCategoryType = null;
      this.adaptedBrandList = [];
      this.adaptedCategoryList = [];
    },
    handleClearDeviceBrand () {
      // 如果选择了适配设备，则保留适配品牌中的对应品牌，删除其余品牌
      if (this.deviceList.length) {
        this.$message({
          message: '适配设备的品牌将被保留',
          type: 'warning',
        });
        this.adaptedBrandList = this.adaptedBrandList.filter(item => this.deviceList.some(device => device.deviceBrandId === item.brandId));
        this.form.adaptedBrandType = this.adaptedBrandList.length ? 1 : null;
        this.$refs.chooseDeviceBrandDialogRef.selectedLists = JSON.parse(JSON.stringify(this.adaptedBrandList));
      } else {
        this.adaptedBrandList = [];
        this.form.adaptedBrandType = null;
        this.$refs.chooseDeviceBrandDialogRef.selectedLists = [];
      }
    },
    handleClearDeviceCategory () {
      // 如果选择了适配设备分类，则保留适配类目中的对应分类，删除其余分类
      if (this.deviceList.length) {
        this.$message({
          message: '适配设备的分类将被保留',
          type: 'warning',
        });
        this.adaptedCategoryList = this.adaptedCategoryList.filter(item => this.deviceList.some(device => device.deviceCategoryId === item.categoryId));
        this.form.adaptedCategoryType = this.adaptedCategoryList.length ? 1 : null;
        this.$refs.chooseDeviceCategoryDialogRef.defaultCheckedKeys = this.adaptedCategoryList.map(item => item.categoryId);
        this.$refs.chooseDeviceCategoryDialogRef.$refs.tree?.setCheckedKeys([]);
      } else {
        this.adaptedCategoryList = [];
        this.form.adaptedCategoryType = null;
        this.$refs.chooseDeviceCategoryDialogRef.defaultCheckedKeys = [];
        this.$refs.chooseDeviceCategoryDialogRef.$refs.tree?.setCheckedKeys([]);
      }
    },
    getRegistration (v) {
      this.form.registerCode = v.registrationCode;
      this.form.managerCategory = v.category;
      this.$refs.JZForm.clearValidate('registerCode');
    },
    handleSelectCategory (v) {
      const categoryId = v.value.slice(-1)[0];
      this.form.merchantGoodsCategoryId = categoryId;
      this.form.merchantGoodsCategoryPath = v.value.join(',');
    },
    handleSelectPlatFormCategory (v) {
      const categoryId = v.value.slice(-1)[0];
      this.form.categoryId = categoryId;
      this.form.categoryPath = v.value.join(',');
      this.detail.categoryName = v.selectedPathLabel;
      this.form.rootCategoryCode = null;
      if (this.detail.categoryName) {
        if (this.detail.categoryName.includes('零配件')) {
          this.form.rootCategoryCode = 'PART';
        } else if (this.detail.categoryName.includes('设备')) {
          this.form.rootCategoryCode = 'DEVICE';
        }
      }
    },
    handleSelectDevice () {
      if (this.from === 'subscribe' && this.disabled) return;
      this.$refs.chooseDeviceDialogRef.deviceType = this.form.deviceType || '1';
      this.$refs.chooseDeviceDialogRef.selectedKeys = this.deviceList.map(item => item.deviceId);
      this.$refs.chooseDeviceDialogRef.selectedLists = this.deviceList.map(item => {
        return {
          id: item.deviceId,
          name: item.deviceName,
          model: item.deviceModel,
          brandId: item.deviceBrandId,
          brandName: item.deviceBrandName,
          categoryId: item.deviceCategoryId,
          categoryName: item.deviceCategoryName,
        };
      });
      this.$refs.chooseDeviceDialogRef.dialogVisible = true;
    },
    handleSelectDeviceBrand () {
      this.$refs.chooseDeviceBrandDialogRef.checkedBrands = this.adaptedBrandList.map(item => item.brandId);
      this.$refs.chooseDeviceBrandDialogRef.adaptedBrandType = this.form.adaptedBrandType === 2 || false;
      this.$refs.chooseDeviceBrandDialogRef.disabledBrands = this.deviceIncludesBrands;
      this.$refs.chooseDeviceBrandDialogRef.selectedLists = this.adaptedBrandList.map(item => ({
        id: item.brandId,
        name: item.brandName,
      }));
      this.$refs.chooseDeviceBrandDialogRef.dialogVisible = true;
    },
    handleSelectDeviceCategory () {
      this.$refs.chooseDeviceCategoryDialogRef.$refs.tree?.setCheckedKeys([]);
      this.$refs.chooseDeviceCategoryDialogRef.defaultCheckedKeys = this.adaptedCategoryList.map(item => item.categoryId);
      this.$refs.chooseDeviceCategoryDialogRef.adaptedCategoryType = this.form.adaptedCategoryType === 2 || false;
      this.$refs.chooseDeviceCategoryDialogRef.disabledCategories = this.deviceIncludesCategories;
      this.$refs.chooseDeviceCategoryDialogRef.dialogVisible = true;
    },
    handleAddRegisterNo () {
      this.$refs.createRegisterNoDialogRef.dialogVisible = true;
    },
    handleChooseRegisterNo () {
      this.$refs.searchRegisterNoDialogRef.dialogVisible = true;
    },
    handleSelectRegisterNo (info) {
      this.form.registerCode = info.registrationCode;
      this.form.managerCategory = info.category;
    },
    handleRemove (file) {
      const index = this.imagesList.findIndex(v => v.url === file.url);
      this.imagesList.splice(index, 1);
      this.form.imageList = this.imagesList;
      this.$refs.JZForm.validateField('imageList');
    },
    // handleDeleteDevice (i) {
    //   this.$delete(this.deviceList, i);
    // },
    handleSaveDevice (data) {
      this.form.deviceType = data.deviceType;
      this.$refs.JZForm.clearValidate('deviceType');
      this.adaptedBrandList = [];
      this.adaptedCategoryList = [];
      if (this.form.deviceType === '2') {
        this.deviceList = [];
        this.form.adaptedBrandType = 2;
        this.form.adaptedCategoryType = 2;
      } else {
        this.deviceList = data.selectedLists.map(item => {
          return {
            deviceId: item.id,
            deviceName: item.name,
            deviceModel: item.model,
            deviceBrandName: item.brandName,
            deviceCategoryId: item.categoryId,
            deviceBrandId: item.brandId,
            deviceCategoryName: item.categoryAllName || item.categoryName,
          };
        });
        this.form.adaptedBrandType = 1;
        this.form.adaptedCategoryType = 1;
      }
    },
    handleSaveDeviceBrand (data) {
      // 处理选中的品牌
      this.form.adaptedBrandType = data.adaptedBrandType === true ? 2 : data.selectedLists.length ? 1 : null;
      const _adaptedBrandList = data.selectedLists.map(item => {
        if (item.id) {
          return {
            brandId: item.id,
            brandName: item.name,
          };
        }
      }).filter(item => !!item);
      this.adaptedBrandList = [...this.copyDeviceIncludesBrands, ..._adaptedBrandList].filter((item, index, arr) => {
        return arr.findIndex(v => v.brandId === item.brandId) === index;
      });
    },
    handleSaveDeviceCategory (data) {
      // 处理选中的分类
      this.form.adaptedCategoryType = data.adaptedCategoryType === true ? 2 : data.selectedLists.length ? 1 : null;
      const _adaptedCategoryList = data.selectedLists.map(item => {
        if (item.id) {
          return {
            categoryId: item.id,
            categoryName: item.name,
          };
        }
      }).filter(item => !!item);
      this.adaptedCategoryList = [...this.copyDeviceIncludesCategories, ..._adaptedCategoryList].filter((item, index, arr) => {
        return arr.findIndex(v => v.categoryId === item.categoryId) === index;
      });
    },
    handleFileLists (file) {
      this.imagesList.push({
        name: file.name,
        url: file.url,
      });
      this.form.imageList = this.imagesList;
      this.$refs.JZForm.clearValidate('imageList');
    },
    handleClose () {
      this.dialogVisible = false;
    },
    handleSure (type) {
      this.$refs.JZForm.validate().then(async valid => {
        if (valid) {
          const api = this.form.id ? goodsSkuUpdate : goodsSkuAdd;
          if (this.form.qualityAssPeriod && !this.form.qualityAssPeriodUnitName) {
            this.$message.warning('请选择质保期/保修期单位');
            return;
          }
          const allQuantity = this.form.serialList.reduce((pre, cur) => pre + Number(cur.quantity), 0);
          if (Number(this.form.quantity) !== allQuantity) {
            this.$confirm('商品数量与明细数量不一致，请检查后重新填写', '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              type: 'warning',
            });
            return;
          }
          if (this.form.medicalFlag === 0) {
            this.form.registerCode = '';
            this.form.managerCategory = '';
          }
          if (this.simpleSpecs) {
            this.form.attributeMap['规格'] = this.simpleSpecs;
          }
          if (this.form.id) {
            this.form.clearPrice = false;
          }

          let params = {
            ...this.form,
            storeId: this.form.storeId || this.storeId,
            saleTypes: this.from === 'subscribe' ? ['SUBSCRIPTION_SALE'] : ['PLATFORM_SALE'],
            releaseStatus: type === 'release' ? 'RELEASED' : 'NOT',
            medicalFlag: !!this.form.medicalFlag || false,
            serialList: this.form.serialList.map(item => {
              return {
                goodsSkuId: this.form.baseSkuId,
                ...item,
              };
            }),
            terminalSource: 'PC',
          };

          if (this.form.rootCategoryCode === 'PART') {
            params.deviceType = this.form.deviceType;
            params.deviceList = this.form.deviceType === '1' ? this.deviceList : null;
            params.adaptedBrandType = this.form.adaptedBrandType;
            params.adaptedBrandList = this.form.adaptedBrandType === 1 ? this.adaptedBrandList : null;
            params.adaptedCategoryType = this.form.adaptedCategoryType;
            params.adaptedCategoryList = this.form.adaptedCategoryType === 1 ? this.adaptedCategoryList : null;
          } else {
            delete params.adaptedBrandType;
            delete params.adaptedCategoryType;
          }

          await api(params);
          if (type === 'save') {
            this.$message.success('保存成功');
          }
          if (type === 'release') {
            this.$message.success('发布成功');
          }
          this.$emit('refresh');
          this.handleClose();
        }
      });
    },
    init () {
      this.form = this.$options.data().form;
      this.simpleSpecs = '';
      this.disabled = false;
      this.chooseGoods = false;
      this.imagesList = [];
      this.deviceList = [];
      this.detail = {};
      this.$nextTick(() => {
        this.$refs.JZForm.resetFields();
      });
      if (this.$refs.chooseGoodsCategoryRef) {
        this.$refs.chooseGoodsCategoryRef.defaultValue = [];
      }
      if (this.$refs.chooseGoodsPlatFormCategoryRef) {
        this.$refs.chooseGoodsPlatFormCategoryRef.defaultValue = [];
      }
      this.adaptedBrandList = [];
      this.adaptedCategoryList = [];
      this.form.serialList = [_.cloneDeep(goodsRow)];
    },
    handleBaseSku (body) {
      const imageList = body.imageList?.length ? body.imageList.map(img => {
        return {
          name: img.name,
          url: img.url,
        };
      }) : [];
      this.disabled = true;
      this.imagesList = imageList;
      this.simpleSpecs = body.simpleSpecs.trim();
      this.deviceList = body.deviceList || [];

      this.adaptedBrandList = (body?.deviceList || []).map(item => {
        if (item.deviceBrandId) {
          return {
            brandId: item.deviceBrandId,
            brandName: item.deviceBrandName,
          };
        }
      }).filter(item => !!item);
      this.adaptedCategoryList = (body?.deviceList || []).map(item => {
        if (item.deviceCategoryId) {
          return {
            categoryId: item.deviceCategoryId,
            categoryName: item.deviceCategoryName,
          };
        }
      }).filter(item => !!item);
      this.copyDeviceIncludesBrands = [];
      this.copyDeviceIncludesCategories = [];
      this.adaptedBrandList.map(item => {
        if (this.deviceList.find(cat => cat.deviceBrandId && cat.deviceBrandId === item.brandId)) {
          this.copyDeviceIncludesBrands.push(item);
        }
      });
      this.adaptedCategoryList.map(item => {
        if (this.deviceList.find(cat => cat.deviceCategoryId && cat.deviceCategoryId === item.categoryId)) {
          this.copyDeviceIncludesCategories.push(item);
        }
      });

      this.form.baseSkuId = body.id || null;
      this.form.rootCategoryCode = body.rootCategoryCode || null;
      this.form.managerCategory = body.managerCategory || null;
      this.form.sn = body.sn || null;
      this.form.anotherName = body.anotherName || null;
      this.form.brandId = body.brandId || null;
      this.form.brandName = body.brandName || null;
      this.form.deviceType = body.deviceType || null;
      this.form.goodsName = body.goodsName || null;
      this.form.goodsUnit = body.goodsUnit || null;
      this.form.merchantGoodsCategoryId = body.merchantGoodsCategoryId || null;
      this.form.merchantGoodsCategoryPath = body.merchantGoodsCategoryPath || null;
      this.form.model = body.model || null;
      this.form.qualityAssPeriod = body.qualityAssPeriod || null;
      this.form.qualityAssPeriodUnitName = body.qualityAssPeriodUnitName || null;
      this.form.registerCode = body.registerCode || null;
      this.form.storeSn = body.storeSn || null;
      this.form.imageList = imageList;
      this.form.medicalFlag = body.medicalFlag ? 1 : 0;
      this.form.attributeMap = {};
      this.form.marketEnable = this.form.marketEnable || 'UPPER';
      this.form.adaptedBrandType = this.adaptedBrandList?.length ? 1 : null;
      this.form.adaptedCategoryType = this.adaptedCategoryList?.length ? 1 : null;

      this.$nextTick(() => {
        if (this.$refs.chooseGoodsCategoryRef) {
          this.$refs.chooseGoodsCategoryRef.defaultValue = this.form.merchantGoodsCategoryPath ? this.form.merchantGoodsCategoryPath.split(',') : [];
        }
      });
    },
    async initForm (id) {
      const { body } = await skuReleaseDetail({
        goodsSkuId: id,
      });
      this.chooseGoods = false;
      this.detail = body || {};
      this.dealDetail(body);
    },
    dealDetail (body) {
      const imageList = body.imageList?.length ? body.imageList.map(img => {
        return {
          name: img.name,
          url: img.url,
        };
      }) : [];
      this.disabled = this.from === 'subscribe';
      this.imagesList = imageList;
      this.simpleSpecs = body.simpleSpecs;
      this.deviceList = body.skuDeviceList ? body.skuDeviceList : [];
      this.adaptedBrandList = (body?.adaptedBrandList || []).map(item => {
        if (item.brandId) {
          return {
            brandId: item.brandId,
            brandName: item.brandName,
          };
        }
      }).filter(item => !!item);
      this.adaptedCategoryList = (body?.adaptedCategoryList || []).map(item => {
        if (item.categoryId) {
          return {
            categoryId: item.categoryId,
            categoryName: item.categoryName,
          };
        }
      }).filter(item => !!item);
      this.copyDeviceIncludesBrands = [];
      this.copyDeviceIncludesCategories = [];
      this.adaptedBrandList.map(item => {
        if (this.deviceList.find(cat => cat.deviceBrandId && cat.deviceBrandId === item.brandId)) {
          this.copyDeviceIncludesBrands.push(item);
        }
      });
      this.adaptedCategoryList.map(item => {
        if (this.deviceList.find(cat => cat.deviceCategoryId && cat.deviceCategoryId === item.categoryId)) {
          this.copyDeviceIncludesCategories.push(item);
        }
      });
      this.form = {
        id: body.goodsSkuId || null,
        storeId: body.storeId || this.storeId || null,
        managerCategory: body.managerCategory || null,
        tenantId: userInfo?.tenantId,
        tenantName: userInfo?.tenantName,
        sn: body.sn || null,
        anotherName: body.anotherName || null,
        brandId: body.brandId || null,
        brandName: body.brandName || null,
        deviceList: body.deviceList || [],
        deviceType: body.deviceType || null,
        goodsName: body.goodsName || null,
        goodsUnit: body.goodsUnit || null,
        merchantGoodsCategoryId: body.merchantGoodsCategoryId || null,
        merchantGoodsCategoryPath: body.merchantGoodsCategoryPath || null,
        categoryId: body.categoryId || null,
        categoryPath: body.categoryPath || null,
        quantity: body.quantity || null,
        price: body.price || null,
        marketEnable: ['UPPER', 'DOWN'].includes(body.marketEnable) ? body.marketEnable : 'UPPER',
        saleTypes: body.saleTypes || ['PLATFORM_SALE'],
        model: body.model || null,
        qualityAssPeriod: body.qualityAssPeriod || null,
        qualityAssPeriodUnitName: body.qualityAssPeriodUnitName || null,
        registerCode: body.registerCode || null,
        storeSn: body.storeSn || null,
        draftFlag: false,
        imageList,
        medicalFlag: body.medicalFlag ? 1 : 0,
        attributeMap: {},
        operatorId: userInfo?.id,
        operatorName: userInfo?.name,
        rootCategoryCode: body.rootCategoryCode || null,
        sourceType: 'XIAOZI_PLATFORM',
        sellingPoint: body.sellingPoint || '',
        serialList: body?.serialList || [],
        adaptedBrandType: body?.adaptedBrandType || null,
        adaptedCategoryType: body?.adaptedCategoryType || null,
      };
      this.$nextTick(() => {
        if (this.$refs.chooseGoodsCategoryRef) {
          this.$refs.chooseGoodsCategoryRef.defaultValue = this.form.merchantGoodsCategoryPath ? this.form.merchantGoodsCategoryPath.split(',') : [];
        }
        if (this.$refs.chooseGoodsPlatFormCategoryRef) {
          this.$refs.chooseGoodsPlatFormCategoryRef.defaultValue = this.form.categoryPath ? this.form.categoryPath.split(',') : [];
        }
      });
      if (this.from === 'subscribe') {
        checkSkuChange({ goodsSkuId: this.form.id }).then(res => {
          if (res.body) {
            this.$message({
              type: 'warning',
              message: '当前发布商品基础档案已变化，发布将以最新数据进行发布',
              duration: 5000,
            });
          }
        });
      }
    },
    async getUnitDictionaryData () {
      const {body} = await getOptionListMap({
        enableFlag: 1,
        typeCode: '7hCUTL',
      });
      if (body?.['7hCUTL']) {
        this.qualityAssPeriodUnitEnums = (body['7hCUTL'] || []).map(item => {
          return {
            label: item.optionName,
            value: item.optionName,
          };
        });
      }
    },
    async getGoodsUnitList () {
      const { body } = await getAttributeDetail({ name: '计量单位', enableFlag: true });
      this.goodsUnitList = body?.valueList || [];
    },
    remoteQueryBrand (query) {
      this.getBrandList(query);
    },
    handleClearBrand () {
      this.form.brandId = null;
      this.form.brandName = null;
      this.getBrandList();
    },
    handleChangeBrand (val) {
      this.form.brandId = val.id;
      this.form.brandName = val.name;
    },
    handleChangeMedical (v) {
      if (v === 0) {
        this.form.qualityAssPeriodUnitName = null;
      } else {
        this.form.qualityAssPeriodUnitName = '月';
      }
    },
    async getBrandList (query = '') {
      if (this.from !== 'subscribe') {
        const { body } = await getBrandPageList1xie({
          name: query,
          pageNumber: 1,
          pageSize: 10,
        });
        this.brandList = body?.records || [];
      } else {
        const { body } = await getBrandPageList({
          nameOrShortName: query,
          enableFlag: true,
          orderBy: [
            {
              orderByProperty: 'createTime',
              orderByType: 'ASC',
            },
          ],
          pageNum: 1,
          pageSize: 10,
        });
        this.brandList = body?.list || [];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.edit-goods-dialog {
  /deep/ .el-dialog__header {
    padding: 16px 20px;
  }
  .title-bar {
    font-weight: normal;
    font-size: 14px;
    color: #929AA6;
    margin-left: 15px;
    .btn {
      font-weight: normal;
      color: #237FFA;
      cursor: default;
    }
  }
  .line {
    height: 1px;
    background-color: #eeeeee;
    margin: 15px 0;
  }
  .device-box {
    display: flex;
    padding-bottom: 15px;
    .device-ctrl {
      flex-shrink: 0;
      height: 30px;
      display: inline-flex;
      align-items: center;
      .label {
        display: inline-block;
        width: 120px;
        text-align: right;
      }
    }
    .device-list {
      display: inline-flex;
      flex-direction: column;
      .device {
        flex-shrink: 0;
        padding: 3px 10px;
        margin: 0 5px;
        border-radius: 4px;
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        &:hover {
          background-color: #eee;
          cursor: default;
        }
      }
    }
  }
  .brand-category-box {
    display: flex;
    align-items: baseline;
    padding-bottom: 15px;
    .device-ctrl {
      flex-shrink: 0;
      height: 30px;
      display: inline-flex;
      align-items: baseline;
      .label {
        display: inline-block;
        width: 120px;
        text-align: right;
      }
    }
  }
  .tip-upload {
    font-weight: 400;
    font-size: 14px;
    color: #929AA6;
  }
  .button {
    color: #409EFF;
    padding: 0 10px;
    cursor: default;
    max-width: 250px;
  }
}
/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #F5F7FA;
}

/deep/ .ant-table-header {
  overflow-y: hidden !important;
}

/deep/ .ant-table-body::-webkit-scrollbar {
  display: none;
}
</style>
